import React, { useState } from 'react'

import { TRACKING_MAPPING } from '@js/common/constants'

import { FormContext } from '@f/elements/FormWrapper/Context'

const FormWrapper = ({
  onSuccess = () => {},
  onChange = () => {},
  onValidationError = () => {},
  forwardedRef = null,
  wtData = {},
  wtDisable = false,
  saveOnChange = false,
  ...props
}) => {
  const findAllFormElements = allChildren => {
    let elements = []

    const loop = children => {
      const childrenArray = React.Children.toArray(children)

      for (const child of childrenArray) {
        if (child.props && child.props.formElement) {
          elements.push({
            name: child.props.name,
            isInput: !!child.props.inputField
          })
        }

        if (child.props && child.props.children) {
          loop(child.props.children)
        }
      }
    }

    loop(allChildren)

    return elements
  }

  const [formElements, setFormElements] = useState({
    status: 'waiting' /* waiting | validating */,
    fields: findAllFormElements(props.children)
  })

  const updateFormElement = field => {
    setFormElements(currentFormElements => {
      return {
        status: currentFormElements.status,
        fields: currentFormElements.fields.map(element => {
          if (element.name === field.name) {
            element.invalidRule = field.invalidRule

            if (field.invalidRule === '') {
              element.value = field.value

              if (field.custom) {
                element.custom = field.custom
              }
            }
          }

          return element
        })
      }
    })
  }

  const handleOnSubmit = event => {
    event.preventDefault()
    let newStatus = formElements.status
    if (formElements.fields.find(element => element.invalidRule)) {
      if (formElements.status === 'waiting') {
        newStatus = 'validating'
      }

      !wtDisable &&
        _wt({
          category: 'form',
          action: 'fail',
          values: formElements.fields
            .filter(element => element.invalidRule)
            .map(currentField => ({
              type:
                TRACKING_MAPPING[currentField.name] &&
                TRACKING_MAPPING[currentField.name].label
                  ? TRACKING_MAPPING[currentField.name].label
                  : currentField.name,
              value: currentField.invalidRule
            })),
          ...(wtData.form ? wtData.form : {})
        })

      onValidationError(
        formElements.fields.filter(
          field => field.invalidRule && field.invalidRule !== ''
        )
      )
    } else {
      newStatus = 'waiting'
      !wtDisable &&
        _wt({
          category: 'form',
          action: 'submit',
          values: formElements.fields.map(currentField => ({
            type:
              TRACKING_MAPPING[currentField.name] &&
              TRACKING_MAPPING[currentField.name].label
                ? TRACKING_MAPPING[currentField.name].label
                : currentField.name,
            value: currentField.isInput
              ? TRACKING_MAPPING[currentField.name] &&
                TRACKING_MAPPING[currentField.name].isTrackingAllowed
                ? currentField.value
                : 'VALUE-HIDDEN'
              : currentField.value
          })),
          ...(wtData.formSubmit
            ? wtData.formSubmit
            : wtData.form
            ? wtData.form
            : {})
        })

      if (onSuccess) {
        onSuccess({
          event,
          elements: formElements.fields
        })
      }
    }

    setFormElements(currentFormElements => {
      return { ...currentFormElements, status: newStatus }
    })
  }

  const attachEventListenersToFormElements = (children, loop = 0) => {
    return React.Children.toArray(children).map((child, index) => {
      if (child.props && child.props.formElement) {
        return React.cloneElement(child, {
          key: `form_element_${loop}_${index}_${child.props.name}`,
          formElements,
          setFormElements: updateFormElement
        })
      }
      if (child.type === React.Fragment) {
        return (
          <React.Fragment key={`form_element_container_${loop}_${index}`}>
            {attachEventListenersToFormElements(child.props.children, loop++)}
          </React.Fragment>
        )
      }
      if (/span|div/.test(child.type) && child.props && child.props.children) {
        const Tag = child.type

        return (
          <Tag {...child.props} key={`form_element_container_${loop}_${index}`}>
            {attachEventListenersToFormElements(child.props.children, loop++)}
          </Tag>
        )
      }
      return child
    })
  }

  return (
    <FormContext.Provider value={{ formElements: formElements.fields }}>
      <form
        onSubmit={handleOnSubmit}
        onChange={
          saveOnChange
            ? e => {
                setTimeout(() => handleOnSubmit(e), 300)
                onChange(e)
              }
            : onChange
        }
        ref={forwardedRef}
        className={`${props.className ? props.className : ''}`}>
        {attachEventListenersToFormElements(props.children)}
      </form>
    </FormContext.Provider>
  )
}

export default FormWrapper
